import { Box, Theme } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { addDays, endOfToday } from "date-fns";
import React from "react";
import {
  Datagrid,
  Filter,
  FunctionField,
  Record,
  TextField,
  TextInput,
} from "react-admin";
import resourceNames from "../../../common/data/resourceNames";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { Void } from "../../common/data-grid-fields/Void";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { DvirHistoryListDto } from "./types";
import ReportIcon from "@material-ui/icons/Report";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useTheme } from "@material-ui/styles";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import dvir from ".";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useResetListSearchField } from "../../../common/hooks/useResetListSearchField";

const ListFilter = (props: any) => {
  useSearchFields(props, ["vehicleName"]);
  useResetListSearchField(props);
  return (
    <Filter {...props}>
      <TextInput
        className="list-view-filter search-box"
        label="resources.common.labels.search"
        source="q"
        alwaysOn
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="list-view-filter"
        label="resources.assets-dvir-history.labels.dateFrom"
        source="dateFrom"
        alwaysOn
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="list-view-filter"
        label="resources.assets-dvir-history.labels.dateTo"
        source="dateTo"
        alwaysOn
      />
    </Filter>
  );
};

export const DvirHistoryList = (props: any) => {
  const theme: Theme = useTheme();
  const permissions = useActionPermissions();
  return (
    <div className="content-container">
      <DefaultProLogsList
        title="resources.assets-dvir-history.name"
        bulkActionButtons={false}
        actions={<Void />}
        filters={<ListFilter />}
        empty={<ProLogsEmpty iconType={dvir.icon} />}
        filterDefaultValues={{
          dateFrom: addDays(endOfToday(), -7).toISOString(),
          dateTo: endOfToday().toISOString(),
        }}
        {...props}
      >
        <Datagrid
          rowClick={
            permissions[permissionNames.assets.dvirHistory.view]
              ? (id, _basePath, _record) => {
                  return `/${resourceNames.ASSETS_DVIR_HISTORY}/${id}`;
                }
              : undefined
          }
        >
          <TextField
            source="vehicleName"
            label="resources.assets-dvir-history.labels.vehicleName"
          />
          <TextField
            source="vehicleMake"
            label="resources.assets-dvir-history.labels.vehicleMake"
          />
          <FunctionField<DvirHistoryListDto & Record>
            source="hasDefects"
            headerClassName="centered-content"
            label="resources.assets-dvir-history.labels.hasDefects"
            render={(record) => (
              <Box className="centered-content">
                {record?.hasDefects ? (
                  <ReportIcon
                    style={{
                      color: theme.palette.error.main,
                    }}
                  />
                ) : (
                  <CheckBoxIcon
                    style={{
                      color: theme.palette.success.main,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <FunctionField<DvirHistoryListDto & Record>
            source="hasUnresolvedDefects"
            headerClassName="centered-content"
            label="resources.assets-dvir-history.labels.hasUnresolvedDefects"
            render={(record) => (
              <Box className="centered-content">
                {record?.hasUnresolvedDefects ? (
                  <ReportIcon
                    style={{
                      color: theme.palette.error.main,
                    }}
                  />
                ) : (
                  <CheckBoxIcon
                    style={{
                      color: theme.palette.success.main,
                    }}
                  />
                )}
              </Box>
            )}
          />
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
